import { Paper } from "@mui/material";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import type { ApiError } from "@entrilia/shared/api/types";
import type { TabularReport } from "../../../api/types/widgetTypes";
import WidgetPreviewCard from "./WidgetPreviewCard";
import WidgetPreviewCardContent from "./WidgetPreviewCardContent";

interface Props {
  widgetSettings: PortalWidget;
  report: TabularReport | undefined;
  columnsLimit?: number;
  noDataText?: string;
  fetchError?: ApiError;
  onViewAllClick: () => void;
}

const TabularWidgetPreviewCard = ({
  widgetSettings,
  report,
  columnsLimit,
  noDataText,
  fetchError,
  onViewAllClick,
}: Props) => {
  const isViewAllDisabled = Boolean(fetchError) || Boolean(noDataText) || !report?.rows.length;

  return (
    <WidgetPreviewCard name={widgetSettings.name} onViewAllClick={onViewAllClick} viewAllDisabled={isViewAllDisabled}>
      <Paper variant="outlined" sx={{ p: 1.5 }}>
        <WidgetPreviewCardContent
          report={report}
          columnsLimit={columnsLimit}
          noDataText={noDataText}
          fetchError={fetchError}
        />
      </Paper>
    </WidgetPreviewCard>
  );
};

export default TabularWidgetPreviewCard;
